import React, { Component } from "react";
import axios from "axios";
import { debounce } from "lodash";
import "./seniorenplatform.scss";
//import list, searchbar, filters component
import SeniorenplatformList from "./SeniorenplatformList/SeniorenplatformList";
import SeniorenplatformFilterList from "./SeniorenplatformFilterList/SeniorenplatformFilterList";
import SeniorenplatformItemDetail from "./SeniorenplatformItemDetail/SeniorenplatformItemDetail";
import { SeniorenplatformAccountPopup } from "./SeniorenplatformLoginPopup/SeniorenplatformAccount";

export default class Seniorenplatform extends Component {
  constructor(props) {
    super();
    axios.defaults.baseURL = props.baseURL;
    this.folderId = props.folderId;
    this.pageSize = props.pageSize;
    this.dictionary = props.dictionary;
    this.urlName = props.urlName;
    this.poId = props.poId;
    this.source = null;

    this.state = {
      //Filter options
      filter: {
        categories: [this.dictionary.evenwichtsoefeningen, this.dictionary.krachtoefeningen],
        types: [this.dictionary.oefeningTerPlaatse, this.dictionary.oefeningMetVerplaatsing, this.dictionary.oefeningOpStoel],
        participants: [this.dictionary.individueel, this.dictionary.perTwee, this.dictionary.inGroep],
        musclegroups: [this.dictionary.armen, this.dictionary.benen, this.dictionary.romp],
        equipments: props.equipments,
      },
      //Filter values
      filterValues: {
        selectedCategories: [],
        selectedTypes: [],
        selectedParticipants: [],
        selectedMuscleGroups: [],
        searchTerm: "",
        onlyFavorites: false,
        selectedEquipments: [],
      },
      //Pagination buttons disabled
      disabledMin: true,
      disabledMax: false,
      //Is loading?
      loading: false,
      //Start page
      pageValueMin: 1,
      //Max amount of pages
      pageValueMax: null,
      //Page nr
      page: 1,
      //All entries to display
      entries: [],
      //Detail view data
      entry: null,
      //Total ammount of items
      totalItems: null,
      //Is Grid or List view
      toggleViewValue: false,
      //Is Mobile filter open?
      filterMobileValue: false,
      //Is detail view visible
      detailView: false,
      //Account popup visible
      accountPopup: false,
    };



    this.filterUpdated();

    this.filterUpdated = this.filterUpdated.bind(this);
    this.handleCategoriesCheckbox = this.handleCategoriesCheckbox.bind(this);
    this.handleMuscleGroupsCheckbox =
      this.handleMuscleGroupsCheckbox.bind(this);
    this.handleTypesCheckbox = this.handleTypesCheckbox.bind(this);
    this.handleParticipantsCheckbox =
      this.handleParticipantsCheckbox.bind(this);
    this.handleFavouritesCheckbox = this.handleFavouritesCheckbox.bind(this);
    this.pageUp = this.pageUp.bind(this);
    this.pageDown = this.pageDown.bind(this);
    this.toggleView = this.toggleView.bind(this);
    this.filterMobile = this.filterMobile.bind(this);
    this.getDetailsOfItem = this.getDetailsOfItem.bind(this);
    this.setDynamicUrl = this.setDynamicUrl.bind(this);
    this.searchUpdated = this.searchUpdated.bind(this);
    this.addToFavorites = this.addToFavorites.bind(this);
    this.removeFromFavorites = this.removeFromFavorites.bind(this);
    this.toggleIsFavorites = this.toggleIsFavorites.bind(this);
    this.checkDetailPage = this.checkDetailPage.bind(this);
    this.handleEquipmentsCheckbox = this.handleEquipmentsCheckbox.bind(this);
    this.isLoggedIn = this.isLoggedIn.bind(this);
  }

  componentDidMount() {
    this.setState({ loading: true });

    this.checkDetailPage();

    window.onpopstate = () => {
      this.checkDetailPage();
    }
  }

  componentDidUpdate() {
    if (this.state.accountPopup) {
      document.querySelector("html").classList.add("u-noscroll");
    }
    else {
      document.querySelector("html").classList.remove("u-noscroll");
    }
  }

  isLoggedIn = () => {
    return this.poId !== null && this.poId !== undefined && this.poId !== "";
  }

  checkDetailPage = () => {
    //Check if is url to detail view
    if (this.props.urlParams && this.props.urlParams.alias) {
      if (this.props.urlParams.alias) {
        this.getDetailsOfItem(this.props.urlParams.alias);
        this.props.urlParams = null;
      }
    }
    else if (window.location.href.includes(`/exercise/`)) {
      this.getDetailsOfItem(window.location.href.split(`/exercise/`)[1].replace(/\//g, ""));

    }
    else if (this.state.detailView) {
      this.getDetailsOfItem(null);
    }
  }

  searchUpdated = debounce((term) => {
    var newFilterValues = Object.assign({}, this.state.filterValues);
    term ? newFilterValues.searchTerm = term : newFilterValues.searchTerm = "";
    this.updateFilterValues(newFilterValues);
  }, 300);

  //Load new data
  filterUpdated() {
    const page = this.state.page;
    const categories = this.state.filterValues.selectedCategories;
    const types = this.state.filterValues.selectedTypes;
    const participants = this.state.filterValues.selectedParticipants;
    const muscleGroups = this.state.filterValues.selectedMuscleGroups;
    const searchTerm = this.state.filterValues.searchTerm;
    const onlyFavorites = this.state.filterValues.onlyFavorites;
    var equipments = this.state.filterValues.selectedEquipments;

    if (this.source) {
      this.source.cancel();
    }

    this.source = axios.CancelToken.source();

    this.setState({ loading: true });

    axios
      .post(
        "/umbraco/api/seniorenplatform/getoverview",
        {
          folderid: this.folderId,
          categories: categories,
          muscleGroups: muscleGroups,
          types: types,
          participants: participants,
          search: searchTerm,
          page: page,
          pageSize: this.pageSize,
          poid: this.poId,
          onlyFavorites: this.state.filterValues.onlyFavorites,
          equipments: equipments,
        },
        { cancelToken: this.source.token }
      )
      .then((response) => {
        const entries = response.data.results;
        const totalItems = response.data.totalItems;

        this.setState({ entries: entries }, () => {
          this.setState({ loading: false });
          const pageValueMax = this.pageSize * this.state.page;

          if (pageValueMax >= totalItems) {
            this.setState({
              pageValueMax: totalItems,
              totalItems: totalItems,
              disabledMax: true,
            });
          } else {
            this.setState({
              pageValueMax: pageValueMax,
              totalItems: totalItems,
              disabledMax: false,
            });
          }
        });
      })
      .catch((err) => {
        if (!axios.isCancel(err)) {
          console.error(err);
        }
        console.log(err);
      });
  }


  //Checkbox for categories update handler
  handleCategoriesCheckbox(e, value) {
    const target = e.target;
    var categories = this.state.filterValues.selectedCategories;
    if (target.checked) {
      categories.push(value);
    } else {
      categories = categories.filter(v => v !== value);
    }


    var newFilterValues = Object.assign({}, this.state.filterValues);
    newFilterValues.selectedCategories = categories;
    this.updateFilterValues(newFilterValues);
  }

  //Checkbox fro Groups update handler
  handleMuscleGroupsCheckbox(e, value) {
    const target = e.target;
    var muscleGroups = this.state.filterValues.selectedMuscleGroups;

    if (target.checked) {
      muscleGroups.push(value);
    } else {
      muscleGroups = muscleGroups.filter(v => v !== value);
    }

    var newFilterValues = Object.assign({}, this.state.filterValues);
    newFilterValues.selectedMuscleGroups = muscleGroups;
    this.updateFilterValues(newFilterValues);

  }

  //Checkbox for types update handler
  handleTypesCheckbox(e, value) {
    const target = e.target;
    var types = this.state.filterValues.selectedTypes;
    if (target.checked) {
      types.push(value);
    } else {
      types = types.filter(v => v !== value);
    }

    var newFilterValues = Object.assign({}, this.state.filterValues);
    newFilterValues.selectedTypes = types;
    this.updateFilterValues(newFilterValues);
  }

  //Checkbox for participants update handler
  handleParticipantsCheckbox(e, value) {
    const target = e.target;
    var participants = this.state.filterValues.selectedParticipants;
    if (target.checked) {
      participants.push(value);
    } else {
      participants = participants.filter(v => v !== value);
    }

    var newFilterValues = Object.assign({}, this.state.filterValues);
    newFilterValues.selectedParticipants = participants;
    this.updateFilterValues(newFilterValues);
  }

  //Checkbox for favorites update handler
  handleFavouritesCheckbox(e, value) {
    const target = e.target;
    var newValue = false;

    if (target.checked) {
      newValue = true;
    }

    var newFilterValues = Object.assign({}, this.state.filterValues);
    newFilterValues.onlyFavorites = newValue;
    this.updateFilterValues(newFilterValues);
  }

  //checkbox for equipments filter
  handleEquipmentsCheckbox(e, value) {
    const target = e.target;
    var equipments = this.state.filterValues.selectedEquipments;
    if (target.checked) {
      var valueToUse = this.props.equipments.filter(v => v.display === value)[0].value;
      equipments.push(value);
    } else {
      equipments = equipments.filter(v => v !== value);
    }

    var newFilterValues = Object.assign({}, this.state.filterValues);
    newFilterValues.selectedEquipments = equipments;
    this.updateFilterValues(newFilterValues);

  }




  updateFilterValues = (newFilterValues) => {
    this.setState({
      filterValues: newFilterValues,
      pageValueMin: 1,
      page: 1,
      disabledMin: true,
      disabledMax: false,
    },
      () => {
        this.filterUpdated();
      }
    );
  }

  //Page up, pagination
  pageUp() {
    const newPage = this.state.page + 1;
    this.setState({ page: newPage }, () => {
      const pageValueMin = this.state.pageValueMin + this.pageSize;
      const pageValueMax = this.state.page * this.pageSize;

      this.setState(
        { pageValueMin: pageValueMin, pageValueMax: pageValueMax },
        () => {
          if (pageValueMin > 1) {
            this.setState({ disabledMin: false });

          }
          if (pageValueMax >= this.state.totalItems) {
            this.setState({ disabledMax: true });

          }
          this.filterUpdated();
        }
      );
    });
  }

  //Page down, pagination
  pageDown() {
    const newPage = this.state.page - 1;
    this.setState({ page: newPage }, () => {
      const pageValueMin = this.state.pageValueMin - this.pageSize;
      const pageValueMax = this.state.page * this.pageSize;

      this.setState(
        { pageValueMin: pageValueMin, pageValueMax: pageValueMax },
        () => {
          if (pageValueMax !== this.state.totalItems) {
            this.setState({ disabledMax: false });

          }
          if (pageValueMin === 1) {
            this.setState({ disabledMin: true });

          }
          this.filterUpdated();
        }
      );
    });
  }

  //Switch between list and grid view
  toggleView(e) {
    const target = e.target;
    if (target.checked) {
      this.setState({ toggleViewValue: true });
      target.parentNode.querySelector(".left").style.color = "#363635";
      target.parentNode.querySelector(".right").style.color = "white";

    } else {
      this.setState({ toggleViewValue: false }, () => {
        target.parentNode.querySelector(".right").style.color = "#363635";
        target.parentNode.querySelector(".left").style.color = "white";

      });
    }
  }

  //Toggle mobile filter
  filterMobile() {
    this.setState({ filterMobileValue: !this.state.filterMobileValue }, () => {
      // ufp.fetchImages(); // eslint-disable-line
    });
  }

  setDynamicUrl(url) {
    if (window && window.location && window.location.pathname && window.location.pathname !== url) {
      window.history.pushState({}, "", url);
    }
  }

  //Get item detail data from api & set state
  getDetailsOfItem(name) {
    let curPath = `${window.location.pathname.split('/exercise/')[0]}`;

    if (!curPath.endsWith('/')) {
      curPath = curPath + "/";
    }

    if (name !== null) {
      axios
        .get(
          `/umbraco/api/seniorenplatform/getdetails?urlName=${name}&folderId=${this.folderId}`
        )
        .then((response) => {
          const entry = response.data;

          entry.isFavorite = this.state.entries.find(e => e.id == entry.id)?.isFavorite;

          this.setState({ entry: entry }, () => {

            const urlName = `${curPath}exercise/${name}/`;
            this.setDynamicUrl(urlName);

            document.querySelector("html").style.overflowX = "hidden";

            this.setState({ detailView: true });

          });

        })
        .catch((err) => {
          // window.history.back();
        });

    }
    else {
      this.setState({ detailView: false });
      this.setDynamicUrl(curPath);
      window.scrollTo(0, 0);
    }
  }

  //Add item to favorites
  addToFavorites(entry) {
    this.setState({ loading: true });

    const id = entry.id;
    const omschrijving = entry.name;
    const newEntries = this.state.entries.map(e => e.id == id ? { ...e, isFavorite: true } : e);
    this.setState({ entries: newEntries });
    axios
      .get(
        `/umbraco/api/seniorenplatform/addtofavorites?poId=${this.poId}&id=${id}&name=${omschrijving}`
      )
      .then((response) => {
        this.setState({ loading: false });
      })
      .catch((err) => {
        console.log(err);
      }
      );
  }

  //Remove item from favorites
  removeFromFavorites(entry) {
    this.setState({ loading: true });

    const id = entry.id;
    const omschrijving = entry.name;
    const newEntries = this.state.entries.map(e => e.id == id ? { ...e, isFavorite: false } : e);
    this.setState({ entries: newEntries });
    axios
      .get(
        `/umbraco/api/seniorenplatform/removefromfavorites?poId=${this.poId}&id=${id}&name=${omschrijving}`
      )
      .then((response) => {
        this.setState({ loading: false });
      }
      )
      .catch((err) => {
        console.log(err);
      }
      );
  }

  //Toggle item in favorites
  toggleIsFavorites(entry) {
    if (this.poId && this.poId !== "") {
      var entryToUse = this.state.entries.find(e => e.id == entry.id);

      if (entryToUse) {
        if (entryToUse.isFavorite) {
          this.removeFromFavorites(entryToUse);

        } else {
          this.addToFavorites(entryToUse);

        }
      }
    }
    else {
      //Show account popup
      this.setState({ accountPopup: true });
    }
  }



    render() {
      return (
        <div
          className={`c-senioren c-content-block u-clear ${this.state.filterMobileValue === true ? "no-padding" : ""
            }`}
        >
          {this.state.detailView === false ? (
            <>
              <SeniorenplatformFilterList
                filters={this.state.filter}
                activeFilters={this.state.filterValues}
                dictionary={this.dictionary}
                handleCategoriesCheckbox={this.handleCategoriesCheckbox}
                handleMuscleGroupsCheckbox={this.handleMuscleGroupsCheckbox}
                handleTypesCheckbox={this.handleTypesCheckbox}
                handleParticipantsCheckbox={this.handleParticipantsCheckbox}
                handleEquipmentsCheckbox={this.handleEquipmentsCheckbox}
                handleFavouritesCheckbox={this.handleFavouritesCheckbox}
                totalItems={this.state.totalItems}
                filterMobile={this.filterMobile}
                filterMobileValue={this.state.filterMobileValue}
                //
                isLoggedin={this.poId && this.poId !== ""}
            />
              <SeniorenplatformList
                searchUpdated={this.searchUpdated}
                entries={this.state.entries}
                dictionary={this.dictionary}
                pageValueMin={this.state.pageValueMin}
                pageValueMax={this.state.pageValueMax}
                totalItems={this.state.totalItems}
                pageUp={this.pageUp}
                pageDown={this.pageDown}
                disabledMin={this.state.disabledMin}
                disabledMax={this.state.disabledMax}
                loading={this.state.loading}
                toggleView={this.toggleView}
                toggleViewValue={this.state.toggleViewValue}
                filterMobile={this.filterMobile}
                getDetailsOfItem={this.getDetailsOfItem}
                toggleIsFavorites={this.toggleIsFavorites}
              />
            </>
          )
            : <SeniorenplatformItemDetail
              loginUrl={this.props.loginUrl}
              registerUrl={this.props.registerUrl}
              entry={this.state.entry}
              dictionary={this.dictionary}
              getDetailsOfItem={this.getDetailsOfItem}
              toggleIsFavorites={this.toggleIsFavorites}
              poId={this.poId}
              entries={this.state.entries}
            />
          }
          {
            this.state.accountPopup && <SeniorenplatformAccountPopup
              dictionary={this.dictionary}
              loginUrl={this.props.loginUrl}
              registerUrl={this.props.registerUrl}
              closePopup={() => this.setState({ accountPopup: false })} />
          }
        </div>
      )
    }
  }
